import React from "react";
import styled from "@emotion/styled";
import { fontFamiliy } from "../constant";

const imgPath = "../../../assets/images/badges/";

const RewardCard = ({ imgName, code, name }) => {
  return (
    <RewardCardContainer>
      <div style={{ width: "70px" }}>
        <img
          src={require("../../../assets/images/badges/" + imgName)}
          width={"67px"}
          height={"60px"}
        />
      </div>
      <div style={{ width: "100%" }}>
        <RewardCode>{code}</RewardCode>
        <br />
        <RewardName>{name}</RewardName>
      </div>
    </RewardCardContainer>
  );
};

export default RewardCard;

const RewardCode = styled.span`
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  /* identical to box height, or 144% */

  text-align: center;

  /* Secondary/500 */

  color: #fb633d;
`;

const RewardName = styled.span`
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  /* identical to box height, or 144% */

  text-align: center;

  /* Neutral / 600 */

  color: #4b5768;
`;

const RewardCardContainer = styled.div`
  height: 80px;
  padding: 8px;

  /* Neutral / 50 */

  background: #f7f8f9;
  border-radius: 8px;
  margin-bottom: 8px;

  display: flex;
  gap: 12px;
  align-items: center;
`;
